import { useState } from 'react';
import NoteContent, { Content } from './NoteContent';
import style from './Note.module.scss';

export interface NoteSectionProps {
  title?: string;
  section?: string;
  content?: Content[];
  isHidden?: boolean;
  readonly?: boolean;
  onFocusChange?: (sectionName: string | null) => void;
}

const NoteSection = ({
  title,
  section,
  content,
  isHidden,
  onFocusChange,
  readonly,
}: NoteSectionProps) => {
  const [_isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
    onFocusChange?.(title || null);
  };

  const handleBlur = () => {
    setIsFocused(false);
    onFocusChange?.(null);
  };

  if (isHidden) {
    return null;
  }

  return (
    <div
      className={style.note__section}
      onFocus={handleFocus}
      onBlur={handleBlur}
      tabIndex={0}
    >
      <div className={style.note__section__title}>
        <strong>{title}</strong>
      </div>
      <NoteContent
        data={content}
        sectionName={section ?? ''}
        readonly={readonly}
      />
    </div>
  );
};

export default NoteSection;
